import type { IconData } from '@stacksjs/iconify-core'

export const contentFilesNewspaper: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.472 9.145h1.53v19.81h-1.53Zm-1.52 19.81h1.52v1.52h-1.52Zm-1.52-16.76h1.52v15.23h-1.52Zm0 16.76h-1.53v1.52H3.052v1.52h25.9v-1.52h-1.52z\"/><path fill=\"currentColor\" d=\"M24.382 28.955h1.52V9.145h4.57v-1.53h-4.57v-4.57h-1.52zm-18.29-1.53h16.77v1.53H6.092Zm12.19-12.19h4.58v4.57h-4.58Zm-6.09 0h4.57v1.53h-4.57Zm0 3.05h4.57v1.52h-4.57Zm-9.14 6.1h19.81v1.52H3.052Zm0-3.05h19.81v1.52H3.052Zm0-3.05h7.62v1.52h-7.62Zm0-3.05h7.62v1.53h-7.62Zm19.81-1.52V6.1H3.052v7.62Zm-18.29-6.1h6.1v1.53h-1.53v1.52h-1.52V12.2h-3.05Zm-3.05-6.09h22.86v1.52H1.522Zm0 27.43h1.53v1.52h-1.53ZM.002 3.045h1.52v25.91H.002Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default contentFilesNewspaper
